import { render, staticRenderFns } from "./customer-area-setting-form.vue?vue&type=template&id=1a3607ab&scoped=true&"
import script from "./customer-area-setting-form.vue?vue&type=script&lang=ts&"
export * from "./customer-area-setting-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3607ab",
  null
  
)

export default component.exports